export default __webpack_public_path__ + "media/images/landlords_page/hero-sm-bd909ae7a4d26c0f50415cec0577a69d.png";